// extracted by mini-css-extract-plugin
export default {"avtalModal":"styles_avtalModal__0tMcn","description":"styles_description__Ad87d","error":"styles_error__fy0Qd","table":"styles_table__BamaI"};